// Password policy — single source of truth for the React client.
// Mirrors backend/utils/password_policy.py. Keep in sync.

export const ALLOWED_SPECIALS = '+_%@!$*~';
const SPECIAL_RE = new RegExp(`[${ALLOWED_SPECIALS.replace(/[$]/g, '\\$')}]`);
const WHITESPACE_RE = /\s/;

export const PASSWORD_POLICY_LINES = [
  '8 to 12 characters',
  `At least one special character from ${ALLOWED_SPECIALS.split('').join(' ')}`,
  'No spaces',
  'Cannot contain your account name (email username)',
  'Cannot match your previous password',
];

function localPart(email) {
  if (!email || typeof email !== 'string' || !email.includes('@')) return '';
  return email.split('@', 1)[0].trim().toLowerCase();
}

/**
 * Returns null on success, or an error string on failure.
 * "previous password match" is not checked client-side — the server is
 * authoritative because we don't have the previous hash.
 */
export function validatePassword(password, { email } = {}) {
  if (!password || typeof password !== 'string') return 'Password is required';
  if (password.length < 8 || password.length > 12) {
    return 'Password must be between 8 and 12 characters';
  }
  if (WHITESPACE_RE.test(password)) return 'Password must not contain spaces';
  if (!SPECIAL_RE.test(password)) {
    return `Password must contain at least one of: ${ALLOWED_SPECIALS.split('').join(' ')}`;
  }
  if (email) {
    const lp = localPart(email);
    if (lp && lp.length >= 3 && password.toLowerCase().includes(lp)) {
      return 'Password must not contain your account name';
    }
    if (password.toLowerCase() === email.trim().toLowerCase()) {
      return 'Password must not match your email';
    }
  }
  return null;
}

/**
 * Returns a checklist [{label, ok}] suitable for rendering a live hint UI.
 */
export function passwordChecklist(password, { email } = {}) {
  const p = password || '';
  const lp = localPart(email);
  return [
    { label: '8 to 12 characters', ok: p.length >= 8 && p.length <= 12 },
    {
      label: `At least one special: ${ALLOWED_SPECIALS.split('').join(' ')}`,
      ok: SPECIAL_RE.test(p),
    },
    { label: 'No spaces', ok: p.length > 0 && !WHITESPACE_RE.test(p) },
    {
      label: 'Does not contain your account name',
      ok: !lp || lp.length < 3 || !p.toLowerCase().includes(lp),
    },
  ];
}
